const setSponsorsList = data => ({
    type: "SET_SPONSORS_LIST",
    data
  });

  export const mutation = {
    setSponsorsList
  };
